import { render, staticRenderFns } from "./NewMessageUploadEditor.vue?vue&type=template&id=729603aa&scoped=true"
import script from "./NewMessageUploadEditor.vue?vue&type=script&lang=js"
export * from "./NewMessageUploadEditor.vue?vue&type=script&lang=js"
import style0 from "./NewMessageUploadEditor.vue?vue&type=style&index=0&id=729603aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729603aa",
  null
  
)

export default component.exports